import React, { useState, useEffect } from "react";
import Layout from "../../../layout/Layout";
import { useNavigate } from "react-router-dom";
import { Button, Input, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import {
  deleteBlogById,
  fetchBlogs,
} from "../../../redux/slice/blog/blogThunk";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import BlogTable from "./components/BlogTable";

const { Search } = Input;
const { Option } = Select;

const BlogDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { blogs, loading } = useSelector((state) => state.blog);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    dispatch(fetchBlogs())
      .unwrap()
      .catch(() => {
        toast.error("Failed to load blogs");
      });
  }, [dispatch]);

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this blog?"
    );
    if (!confirmed) return;

    try {
      await dispatch(deleteBlogById(id)).unwrap();
      await dispatch(fetchBlogs()).unwrap();
      toast.success("Blog deleted successfully");
    } catch (error) {
      toast.error("Failed to delete blog");
    }
  };

  const handleEdit = (id) => {
    navigate(`/blog-details/edit/${id}`);
  };

  const handleView = (id) => {
    navigate(`/blog-details/view/${id}`);
  };

  const filteredBlogs = blogs.filter((blog) => {
    const matchesSearch =
      blog?.title?.toLowerCase().includes(searchText.toLowerCase()) ||
      blog?.tags?.some((tag) =>
        tag.toLowerCase().includes(searchText.toLowerCase())
      );
    const matchesStatus =
      statusFilter === "all" || blog?.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <Layout>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h3 className="h3">Blog Management</h3>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          size="large"
          onClick={() => navigate("/blog-details/create")}
          className="btn btn_contained_black fs_12 btn-sm text-white px-3"
        >
          Create New Blog
        </Button>
      </div>

      <div className="space-y-6">
        {/* Search and Filter */}
        <div className="d-flex align-items-center gap-4 mb-4">
          <Search
            placeholder="Search blogs by title or tags..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ maxWidth: "28rem" }}
          />
          <Select
            value={statusFilter}
            onChange={setStatusFilter}
            className="w-40"
          >
            <Option value="all">All Status</Option>
            <Option value="published">Published</Option>
            <Option value="draft">Draft</Option>
          </Select>
        </div>

        {/* Blog Table or Fallback */}
        {loading ? (
          <p className="text-center text-muted py-5">Loading blogs...</p>
        ) : filteredBlogs.length ? (
          <BlogTable
            data={filteredBlogs}
            onEdit={handleEdit}
            onView={handleView}
            onDelete={handleDelete}
          />
        ) : (
          <div className="text-center text-muted py-5">
            No blogs found for the current filters.
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BlogDetails;
